export class DeleteItemModel {
  itemId: Array<number>;
  updatedDbId: Array<number>;
  screenName: string;

  constructor() {
    this.itemId = [];
    this.updatedDbId = [];
    this.screenName = '';
  }
}
